module.exports = __webpack_public_path__ + "img/深圳.22682154.png";